import React from 'react';
import { Spinner } from 'reactstrap';

/**
 * Full-viewport processing overlay for actions that hit an external
 * supplier API (redemption approve/decline, mark redeemer safe) and can
 * take several seconds - a button-level spinner alone is easy to miss,
 * and without any feedback the page looks hung.
 */
const FullPageLoader = ({ show, text = 'Processing...' }) => {
    if (!show) return null;

    return (
        <div
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(255, 255, 255, 0.65)',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 2000,
            }}
        >
            <Spinner color="primary" style={{ width: '3rem', height: '3rem' }} />
            <div className="mt-3" style={{ fontWeight: 600 }}>{text}</div>
        </div>
    );
};

export default FullPageLoader;
